module.exports = __webpack_public_path__ + "static/img/product_tagWatch.fd0cd98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/product_tagWatch.jpg
// module id = HFeZ
// module chunks = 0